<template>
    <div class="container">
        <div class="topBg">
            <mt-swipe ref="swipe" :auto="0" @change="handleChange" :show-indicators="false" >
                <mt-swipe-item v-for="(item,index) in biaoList" :key="index">
                    <div class="swiper_bg">
                        <div class="swiper_top">
                            <div class="swiper_top_item1">
                                <span class="swiper_top_span1">仪表号</span>
                                <span class="swiper_top_span2">{{item.meterNo}}</span>
                            </div>
                            <div class="swiper_top_item2">
                                <span class="swiper_top_span1">仪表名</span>
                                <span class="swiper_top_span2">{{item.name}}</span>
                            </div>
                            <span class="swiper_top_span3">{{index+1}}/{{biaoList.length}}</span>
                        </div>
                        <div class="swiper_footer">
                            <span class="swiper_top_span4">{{item.merchantName}}</span>
                            <span class="swiper_top_span5">{{item.storeNo}}</span>
                        </div>

                    </div>
                </mt-swipe-item>
            </mt-swipe>
            <img @click="changeSwipeIndex(-1)"
                    class="prevIcon"
                    src='../../assets/images/btn_coupon_last@2x.png'/>
            <img @click="changeSwipeIndex(1)"
                    class="nextIcon"
                    src='../../assets/images/btn_coupon_next@2x.png'/>

        </div>
        <div class="listView"  v-if="dataList.length>0">
            <scroll :allLoaded="allLoaded"
                    :data="dataList"
                    @pulldown="loadData"
                    @loadUp="loadup" >
                    <div class="listItem" v-for="(item,index) in dataList" :key="index">
                        <div class="listItemTop">
                            <div class="listItemTop_dot"></div>
                            <span class="listItemTop_span">{{item.group}}</span>
                        </div>
                        <div class="list_bodyItem" v-for="(jitem,jindex) in item.list" :key="jindex">
                             <div class="list_bodyItem_line">
                                 <span class="list_bodyItem_span1">订单编号:{{jitem.orderNo}}</span>
                                 <span class="list_bodyItem_span2">支付金额</span>
                             </div>
                             <div class="list_bodyItem_line">
                                 <span class="list_bodyItem_span3">支付时间:{{jitem.payDate}}</span>
                                 <span class="list_bodyItem_span4">+ {{jitem.paymentAmount}} 元</span>
                             </div>
                        </div>
                    </div>
            </scroll>
         </div>
    </div>
</template>

<script>
import util from "../../utils/util";
import storage from '../../utils/storage';
import Scroll from "../../components/scroll";
import { mapState,mapActions } from "vuex";
import {callSpaceUp} from "../../utils/api";
export default {
  name: "rechargeRecord",
  components: {  Scroll },
  data() {
    return {
       timeout:'',
       biaoList:[],
       dataList:[],
       allLoaded:true,

       swipeIndex:0,
       selectIntelligence:'',
       intelligenceCode:'' , //表号
       storeNo:'', //单元号
       page:1,
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    this.getDeviceList()
  },
  methods: {
        ...mapActions(['getMarketInfo','getUserInfo','getTenantInfo','getTenantInfoList','getTheme','getHolidayStyle']),
       loadData(){
           this.page = 1;
            this.queryDevicePaymentByDeviceId()

       },
       loadup(){
            if(!this.allLoaded){
                this.page =this.page+1;
                this.queryDevicePaymentByDeviceId()
            }

       },
        getDeviceList() {
            var params = {
                userId: this.common.userId,
                marketId: this.common.marketInfo.id,
                companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                page:1,
                pageSize:100,
                spaceName:'',
                platform: "RST",
                merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
                url: "/property/rstRepair/queryDeviceMonitorPage"
            }
            callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                   var list =res.body.data.list
                    for(var i=0;i<list.length;i++){
                        var item =list[i];
                        var pitem  =item.prpDeviceSpaceRelBeans
                        if(pitem && pitem.length>0){
                            item.storeNo = pitem[0].subProjectName +'-'+pitem[0].buildName+"-"+pitem[0].spaceName
                        }
                    }
                    this.biaoList =list;
                    if(list.length>0){
                        this.intelligenceCode =list[0].id
                        this.storeNo = list[0].storeNo
                        this.selectIntelligence =this.biaoList[0]
                       // this.getYuer()
                       this.queryDevicePaymentByDeviceId()
                    }else{
                        util.showToast("没有相关电表数据")
                    }
                }
            });
        },

         //获取充值记录
        queryDevicePaymentByDeviceId(){
            var params = {
                userId: this.common.userId,
                marketId: this.common.marketInfo.id,
                companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                platform: "RST",
                merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
                deviceId:this.intelligenceCode,
                page:this.page,
                pageSize:20,
                url: "/property/rstRepair/queryDevicePaymentByDeviceId"
            }
            if(this.year){
                params.beginTime =this.year+"-01"
            }
            callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                   console.log('1111')
                   if(this.page==1){
                      this.dataList =[]
                   }
                   var list = res.body.data.list;
                   if(list.length<20){
                       this.allLoaded=true;
                   }

                //    var bList =[];
                   for(var i=0;i<list.length;i++){
                        var item =  list[i];
                        // var reg = new RegExp( '.' , "g" )
                        // var timeStr =   item.writeTime.replace(reg, '/')
                        // replace 全部无效  先写死2次replace
                        //var timeStr =item.writeTime.replace('.','/');
                        // timeStr =timeStr.replace('.','/');
                        var timeStr =item.payDate
                        timeStr =timeStr.replace(/\./g, '/')
                        var date = new Date(timeStr);
                        const year = date.getFullYear()
                        const month = date.getMonth() + 1
                        const day = date.getDate()
                        item.group = year+"年"+month+"月";
                        item.timeStr =  month+"-"+day;
                        var hasItem =false;
                        for(var j=0;j<this.dataList.length;j++){
                            var rItem =this.dataList[j];
                            if(rItem.group == item.group){
                                hasItem =true;
                                // rItem.allkwh = rItem.allkwh+item.eachUsage
                                rItem.list.push(item)
                                break;
                            }
                        }

                        if(hasItem ==false){
                            var newItem = {
                                group:item.group,
                                list:[]
                            }
                            newItem.list.push(item);
                            this.dataList.push(newItem);
                        }

                   }

                }
            });


        },


       handleChange(index){
            this.swipeIndex =index
            clearTimeout(this.timeout) //防止连续滚动触发
            this.timeout = setTimeout(() => {
                 this.swipeIndex =index
                 console.log("handleChangeIndex ===  "  + index)
                 this.intelligenceCode =this.biaoList[index].id
                 this.storeNo = this.biaoList[index].storeNo
                 this.selectIntelligence =this.biaoList[index]
                 this.loadData();
                 //this.getYuer();
            }, 500)
        },
        changeSwipeIndex(index){
            // console.log("changeSwipeIndex ===  "  + this.$refs.swipe.index)
            // var swipeIndex = this.$refs.swipe.index; //轮播当前索引
            if (index==1) {
                //if(this.swipeIndex<this.biaoList.length){
                    this.$refs.swipe.next(); // 转到下一张轮播图
                //}
                // this.swipeIndex=this.$refs.swipe.index
            } else if (index==-1) {
               // if(this.swipeIndex>0){
                    this.$refs.swipe.prev(); // 转到前一张轮播图
                //}
                //  this.swipeIndex=this.$refs.swipe.index
            }
            console.log("hpRecharge    === " +  this.swipeIndex)
        }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  width: 100vw;
  height: 100vh;
  background: #F3F4F6;
  display: flex;
 .flex(column);
  .listView {
    flex: 1;
    background-color: #F3F4F6 ;
    width: 710px;
    min-height: 500px;
    margin-bottom: 20px;
    margin-left: 20px;
    margin-top: 20px;
    // width: 710px;
    // background: #FFFFFF;
    // flex-direction: column;
     border-radius: 8px 8px 8px 8px;
}

}
.topBg{
    flex-direction: column;
    position: relative;
    width: 750px;
    height: 322px;
    background: #FFFFFF;
}

//轮播图
.swiper_bg{
    margin-top: 28px;
    margin-left: 28px;
    margin-right: 28px;
    width: 694px;
    height: 266px;
    background: linear-gradient(270deg, #FFBE00 0%, #FFA100 100%);
    box-shadow: 0px 8px 24px 0px #FFEAC8;
    border-radius: 12px;
    flex-direction: column;
}
.swiper_top{
    width: 694px;
    display: flex;
    height: 136px;
    flex-direction: column;
    position: relative;
}
.swiper_top_item1{
    width: 694px;
    display: flex;
    height: 40px;
    margin-top: 28px;
    flex-direction: row;
}
.swiper_top_item2{
    width: 694px;
    height: 40px;
    display: flex;
    margin-top: 8px;
    flex-direction: row;
}
.swiper_top_span1{
    margin-left: 28px;
    width: 100px;
    display: flex;
    height: 40px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
}
.swiper_top_span2{
    width: 452px;
    height: 40px;
    display: flex;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
}
.swiper_top_span3{
    position: absolute;
    right: 28px;
    top:28px;
    height: 32px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 32px;
}
.swiper_footer{
    width: 694px;
    height: 130px;
    background: rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
}
.swiper_top_span4{
     width: 638px;
    margin-top: 20px;
    margin-left: 28px;
    height: 34px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 34px;
}
.swiper_top_span5{
     margin-top: 8px;
    margin-left: 28px;
    width: 638px;
    height: 40px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
}
// 箭头。
.prevIcon{
    position: absolute;
    left: 20px;
    top: 140px;
    width: 44px;
    height: 44px;
    display: block;

}
.nextIcon{
    position: absolute;
    right: 20px;
    top: 140px;
    width: 44px;
    height: 44px;
    display: block;
}
//listView
.listItem{
    display: flex;
    flex-direction: column;
    width: 710px;
    border-bottom: 1px solid #EAEAEA;
}
.listItemTop{
    width: 710px;
    display: flex;
    height: 88px;
    background: #FCFCFC;
    flex-direction: row;
    align-items: center;
}
.listItemTop_dot{
    margin-left: 28px;
    width: 6px;
    height: 28px;
    background: #FD9838;

}
.listItemTop_span{
    margin-left: 16px;
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
}
.list_bodyItem{
    border-top: 1px solid #EAEAEA;;
    width: 710px;
    height: 100px;
    display: flex;
    background: #FFFFFF;
    flex-direction: column;
    padding-bottom: 28px;
}

.list_bodyItem_line{
    flex-direction: row;
    justify-content: space-between;
    width: 710px;
    display: flex;
}
.list_bodyItem_span1{
    margin-left: 28px;
    margin-top: 28px;
    height: 36px;
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    line-height: 36px;
}
.list_bodyItem_span2{
    margin-right: 28px;
    margin-top: 28px;
    height: 36px;
    font-size: 24px;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
}

.list_bodyItem_span3{
    margin-left: 28px;
    margin-top: 16px;
    height: 36px;
    font-size: 26px;
    color: #999999;
    line-height: 36px;
}

.list_bodyItem_span4{
    margin-right: 28px;
    margin-top: 16px;
    height: 36px;
    font-size: 26px;
    font-weight: 400;
    color: #FD9838;
    line-height: 30px;
}


</style>